import { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link", "blockquote", "code-block"],
        [{ align: [] }],
        ["clean"],
    ],
};

const formats = ["header", "bold", "italic", "underline", "strike", "list", "color", "background", "link", "blockquote", "code-block", "align"];

export default function RichEditor({ value, onChange, placeholder = "লিখুন..." }) {
    const [val, setVal] = useState(value || "");
    useEffect(() => { setVal(value || ""); }, [value]);
    return (
        <div className="rich-editor bg-white rounded-lg overflow-hidden border border-brand-light">
            <ReactQuill
                theme="snow"
                value={val}
                onChange={(content) => { setVal(content); onChange(content); }}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
            />
        </div>
    );
}
